import React, { useEffect, useState, useRef } from "react";
import "./Anonymity.scss";
import { Breadcrumb, Modal } from "react-bootstrap";
import EziLoader from "components/EziLoader";
import Axios from "utility/Axios";
import configURL from "config/config";
import { toast } from "react-toastify";
import DataTable from "components/DataTable";
import SweetSearch from "components/SweetSearch";
import { useNavigate, useLocation } from "react-router-dom";
import '../../assets/scss/_ezi_modal.scss';
import Select from 'react-select';

const SurveyWiseAnonymity = () => {
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [surveyList, setSurveyList] = useState([]);
    const [dataColumn, setDataColumn] = useState([{}]);
    const [showModal, setShowModal] = useState(false);
    const [reportListing, setReportListing] = useState([]);
    const [selectedReport, setSelectedReport] = useState();
    const [rounderOptions, setRounderOptions] = useState([]);
    const [aggregatorOptions, setAggregatorOptions] = useState([]);
    const [providerLoaded, setProviderLoaded] = useState(false);
    const [logicOptionsMap, setLogicOptionsMap] = useState({});
    const per_page = 10;
    const inputSearch = useRef(null);
    var searchTimer = null;
    const navigate = useNavigate();
    const location = useLocation();
    const companyName = location?.state?.companyData?.name

    const handleEditSurveySetting = (row = {}) => {
        let formData = new FormData();
        formData.append("is_partner_report_type", true);
        formData.append("account_id", location.state.companyData.account_id);
        Axios.post(configURL.get_partner_report_types_mapping, formData).then((response) => {
            if (response.data.success === true) {
                // Build logic options map for this report type
                const logicMap = {};
                response.data.data.forEach(item => {
                    const logicKeys = item.logic_keys || [];
                    logicMap[item.report_type_id] = logicKeys.map(k => ({
                        label: k.toUpperCase(),
                        value: k
                    }));
                });
                setLogicOptionsMap(logicMap);
                let isPresentReport = response.data.data.filter((item) => item.report_type_id === row.report_type_id);
                if (isPresentReport.length > 0) {
                    let listing = response.data.data.map((item) => ({ label: item.name, value: item.report_type_id, master_configuration_json: item.master_configuration_json, survey_id: row.id, survey_name: row.display_name }));
                    setShowModal(true);
                    let configurations = { ...listing.filter((item) => item.value === row.report_type_id)[0], master_configuration_json: JSON.parse(row.master_configuration_json) };
                    let modifiedConfig = {
                        ...configurations?.master_configuration_json,
                        round_decimal_point_100_scale: configurations?.master_configuration_json?.round_decimal_point_100_scale || 0,
                        round_decimal_point_5_scale: configurations?.master_configuration_json?.round_decimal_point_5_scale || 0,
                        aggregator_5_scale: configurations?.master_configuration_json?.aggregator_5_scale || null,
                        aggregator_100_scale: configurations?.master_configuration_json?.aggregator_100_scale || null,
                        rounder_5_scale: configurations?.master_configuration_json?.rounder_5_scale || null,
                        rounder_100_scale: configurations?.master_configuration_json?.rounder_100_scale || null,
                        default_logic: configurations?.master_configuration_json?.default_logic || null
                    };
                    setSelectedReport({ ...configurations, master_configuration_json: modifiedConfig });
                    setReportListing(listing);
                } else {
                    toast.warn("Report type not found");
                }
            } else {
                toast.warn(response.data.message);
            }
        }).catch((error) => {
            toast.warn(error.message);
        });
    };

    const handleTableChange = (type, props) => {
        setLoading(true);
        switch (type) {
            case "pagination":
                getUsersList(props.page);
                break;
            case "sort":
                getUsersList();
                break;
            default:
                break;
        }
    };

    const getUsersList = (page = 1) => {
        let formData = new FormData();
        let userSearch = inputSearch.current.value;
        formData.append("page", page);
        formData.append("per_page", per_page);
        formData.append("search", userSearch);
        formData.append("account_id", location.state.companyData.account_id);
        Axios.post(configURL.survey_list, formData).then((response) => {
            if (response.data.success === true) {
                const columnData = [
                    { dataField: "name", text: "Survey Name" },
                    { dataField: "report_type_name", text: "Report Type" },
                    { dataField: "created_at", text: "Created At" },
                ];
                columnData.push({
                    dataField: "action",
                    text: "Action",
                    headerFormatter: headingFormatter,
                    formatter: actionFormatter,
                });
                setDataColumn(columnData);
                setSurveyList(response.data.result.data);
                setPagination(response.data.result.pagination);
                setLoading(false);
                setSearchLoading(false);
            } else {
                toast.warn(response.data.message);
            }
        });
    };

    const handleTableSearch = () => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => {
            setSearchLoading(true);
            getUsersList();
        }, 500);
    };

    const headingFormatter = (column, colIndex) => {
        return <div className="action-heading-name">Action</div>;
    };

    const actionFormatter = (cell, row) => {
        return (
            <div className="dt-bootstrap-edit-delte-wrap">
                <button
                    type="button"
                    className="action-btn"
                    onClick={() => {
                        handleEditSurveySetting(row);
                    }}
                    title={"Edit"}
                >
                    Edit
                </button>
            </div>
        );
    };

    const saveReportAnonymity = () => {
        let formData = new FormData();
        formData.append("survey_id", selectedReport.survey_id);
        formData.append("report_type_id", selectedReport.value);
        formData.append("account_id", location.state.companyData.account_id);
        formData.append("master_configuration_json", JSON.stringify({ ...selectedReport.master_configuration_json, round_decimal_point_100_scale: selectedReport.master_configuration_json.round_decimal_point_100_scale || 0, round_decimal_point_5_scale: selectedReport.master_configuration_json.round_decimal_point_5_scale || 0 }));
        formData.append("account_id", location.state.companyData.account_id);
        Axios.post(configURL.survey_update, formData).then((response) => {
            if (response.data.success === true) {
                setShowModal(false);
                toast.success(response.data.message);
                getUsersList();
                setSelectedReport();
            } else {
                toast.warn(response.data.message);
            }
        });
    }

    const getProviderDetail = () => {
        let formData = new FormData();
        Axios.post(configURL.providers, formData).then((response) => {
            if (response.data.success === true) {
                const { aggregators = [], rounders = [] } = response.data.result || {};

                setAggregatorOptions(
                    aggregators.map(item => ({
                        label: item.name,
                        value: item.key
                    }))
                );
                setRounderOptions(
                    rounders.map(item => ({
                        label: item.name,
                        value: item.key
                    }))
                );
                setProviderLoaded(true);
            } else {
                setProviderLoaded(true);
            }
        }).catch(() => {
            setProviderLoaded(true);
        });
    };



    // const handleChangeReport = (e) => {
    //     let reportType = reportListing.filter((item) => item.value === e.target.value)[0];
    //     setSelectedReport(reportType);
    // }

    useEffect(() => {
        setLoading(true);
        getUsersList();
        getProviderDetail();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <React.Fragment>
            <section className="Page-Users">
                <div className="breadcrumb_ezi">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate('/dashboard')}>Dashboard</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={() => navigate(-1)}>Companies</Breadcrumb.Item>
                        <Breadcrumb.Item >Surveys ({companyName})</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="column-header">
                        <h1 className="page-heading">Surveys ({companyName})</h1>
                    </div>
                </div>
                <div className="users-table-content">
                    <SweetSearch
                        ref={inputSearch}
                        change={handleTableSearch}
                        loading={searchLoading}
                    />
                    {surveyList.length > 0 && dataColumn.length > 0 && (
                        <div className="saved_participants_table">
                            <DataTable
                                data={surveyList}
                                columns={dataColumn}
                                hideSelectAll
                                page={pagination.current_page}
                                sizePerPage={per_page}
                                onTableChange={handleTableChange}
                                keyField="id"
                                totalSize={pagination.total}
                                hideSelect
                            />
                        </div>
                    )}
                    {surveyList.length === 0 && (
                        <div className="saved_participants_table">
                            <DataTable data={[]} columns={[{}]} keyField="id" hideSelect />
                        </div>
                    )}
                </div>
                {showModal &&
                    <Modal show={showModal} className="ezi-modal-wrapper theme-modal-wrapper survey-wise-anonymity-modal" size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered>
                        <Modal.Header className="ezi-modal-header">
                            <Modal.Title id="contained-modal-title-vcenter" className="theme-modal-title ezi-modal-header-title" >
                                <span className="theme-modal-title-text">Survey Anonymity ({selectedReport?.survey_name})</span>
                                <span className="ezi-modal-close" onClick={() => { setShowModal(false); setSelectedReport() }}></span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">Report Type</label>
                                            <select name="industry" value={selectedReport.value} className="form-control" onChange={(e) => setSelectedReport(reportListing.filter(item => item.value === e.target.value)[0])}>
                                                {/* <option value={selectedReport.value}>{selectedReport.label}</option> */}
                                                {reportListing.length > 0 && reportListing.map((item, index) => <option key={index} value={item.value}>{item.label}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">Anonymity</label>
                                            <input type="number"
                                                placeholder="Anonymity"
                                                name="companyname"
                                                className="form-control"
                                                min={0}
                                                value={selectedReport?.master_configuration_json.anonymity_value !== null ? selectedReport?.master_configuration_json.anonymity_value : ''}
                                                onChange={(e) => (e.target.value === '' || /^\d+$/.test(e.target.value)) && setSelectedReport({ ...selectedReport, master_configuration_json: { ...selectedReport?.master_configuration_json, anonymity_value: e.target.value } })}
                                            />
                                            {/* {errors.companyname && errors.companyname.type === 'required' &&
                                                <span className="error_cu">Company Name is required</span>}
                                            {errors.companyname && errors.companyname.type === 'pattern' &&
                                                <span className="error_cu">Company Name is required</span>} */}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">Manager anonymity</label>
                                            <input type="number"
                                                placeholder="Manager anonymity"
                                                name="companyname"
                                                className="form-control"
                                                min={0}
                                                value={selectedReport?.master_configuration_json.manager_anonymity_value !== null ? selectedReport?.master_configuration_json.manager_anonymity_value : ''}
                                                onChange={(e) => (e.target.value === '' || /^\d+$/.test(e.target.value)) && setSelectedReport({ ...selectedReport, master_configuration_json: { ...selectedReport?.master_configuration_json, manager_anonymity_value: e.target.value } })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">Third party anonymity</label>
                                            <input type="number"
                                                placeholder="Third party anonymity"
                                                name="companyname"
                                                className="form-control"
                                                min={0}
                                                value={selectedReport?.master_configuration_json.tpi_anonymity_value !== null ? selectedReport?.master_configuration_json.tpi_anonymity_value : ''}
                                                onChange={(e) => (e.target.value === '' || /^\d+$/.test(e.target.value)) && setSelectedReport({ ...selectedReport, master_configuration_json: { ...selectedReport?.master_configuration_json, tpi_anonymity_value: e.target.value } })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">
                                                Default Logic
                                            </label>
                                            <Select
                                                value={
                                                    (logicOptionsMap[selectedReport?.value] || []).find(
                                                        opt => opt.value === selectedReport?.master_configuration_json.default_logic
                                                    ) || null
                                                }
                                                options={logicOptionsMap[selectedReport?.value] || []}
                                                onChange={(opt) =>
                                                    setSelectedReport({
                                                        ...selectedReport,
                                                        master_configuration_json: {
                                                            ...selectedReport.master_configuration_json,
                                                            default_logic: opt?.value || null
                                                        }
                                                    })
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">
                                                Aggregator (5 Scale)
                                            </label>
                                            <Select
                                                value={
                                                    aggregatorOptions.find(
                                                        opt => opt.value === selectedReport?.master_configuration_json.aggregator_5_scale
                                                    ) || null
                                                }
                                                options={aggregatorOptions}
                                                onChange={(opt) =>
                                                    setSelectedReport({
                                                        ...selectedReport,
                                                        master_configuration_json: {
                                                            ...selectedReport.master_configuration_json,
                                                            aggregator_5_scale: opt?.value || null
                                                        }
                                                    })
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">
                                                Aggregator (100 Scale)
                                            </label>
                                            <Select
                                                value={
                                                    aggregatorOptions.find(
                                                        opt => opt.value === selectedReport?.master_configuration_json.aggregator_100_scale
                                                    ) || null
                                                }
                                                options={aggregatorOptions}
                                                onChange={(opt) =>
                                                    setSelectedReport({
                                                        ...selectedReport,
                                                        master_configuration_json: {
                                                            ...selectedReport.master_configuration_json,
                                                            aggregator_100_scale: opt?.value || null
                                                        }
                                                    })
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">
                                                Rounder (5 Scale)
                                            </label>
                                            <Select
                                                value={
                                                    rounderOptions.find(
                                                        opt => opt.value === selectedReport?.master_configuration_json.rounder_5_scale
                                                    ) || null
                                                }
                                                options={rounderOptions}
                                                onChange={(opt) =>
                                                    setSelectedReport({
                                                        ...selectedReport,
                                                        master_configuration_json: {
                                                            ...selectedReport.master_configuration_json,
                                                            rounder_5_scale: opt?.value || null
                                                        }
                                                    })
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">
                                                Rounder (100 Scale)
                                            </label>
                                            <Select
                                                value={
                                                    rounderOptions.find(
                                                        opt => opt.value === selectedReport?.master_configuration_json.rounder_100_scale
                                                    ) || null
                                                }
                                                options={rounderOptions}
                                                onChange={(opt) =>
                                                    setSelectedReport({
                                                        ...selectedReport,
                                                        master_configuration_json: {
                                                            ...selectedReport.master_configuration_json,
                                                            rounder_100_scale: opt?.value || null
                                                        }
                                                    })
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3 ezi-material-group">
                                            <label className="industry_list text-secondary mb-1">Round decimal (100 scale)</label>
                                            <input type="number"
                                                placeholder="Round decimal (100 scale)"
                                                name="companyname"
                                                className="form-control"
                                                min={0}
                                                value={selectedReport?.master_configuration_json.round_decimal_point_100_scale}
                                                onChange={(e) => e.target.value <= 2 && (e.target.value === '' || /^\d+$/.test(e.target.value)) && setSelectedReport({ ...selectedReport, master_configuration_json: { ...selectedReport?.master_configuration_json, round_decimal_point_100_scale: e.target.value } })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="industry_list text-secondary mb-1">Round decimal (5 scale)</label>
                                            <input type="number"
                                                placeholder="Round decimal (5 scale)"
                                                name="companyname"
                                                className="form-control"
                                                min={0}
                                                value={selectedReport?.master_configuration_json.round_decimal_point_5_scale}
                                                onChange={(e) => e.target.value <= 2 && (e.target.value === '' || /^\d+$/.test(e.target.value)) && setSelectedReport({ ...selectedReport, master_configuration_json: { ...selectedReport?.master_configuration_json, round_decimal_point_5_scale: e.target.value } })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="theme-modal-footer d-flex justify-content-end align-items-center mt-3">
                                <button type="button" className="close-theme-btn" onClick={() => { setShowModal(false); setSelectedReport() }}>Close</button>
                                <input type="submit" value="Save" onClick={saveReportAnonymity} className="btn-ripple ezi-pink-btn add-theme-btn" />
                            </div>
                        </Modal.Body>
                    </Modal>
                }
            </section>
            {loading && <EziLoader />}
        </React.Fragment>
    );
};

export default SurveyWiseAnonymity;
